import {
  Container,
  Box,
  Alert,
  Snackbar,
  Backdrop,
  CircularProgress,
  Typography,
  Paper,
  Icon,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckoutFooter from "../components/footer";
import AppConfig from "../../appConfig";
import axios from "../../axios";
import usePageTitle from "../pageTitle";
import FormSectionBuilder from "../components/data_forms/form_section_builder";
import { useGeolocated } from "react-geolocated";

function DataCapturePage() {
  const [pageTitle, setPageTitle] = useState("Data Capture");
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [banner, setBanner] = useState(null);
  const [campaign, setCampaign] = useState(null);
  const [dataForm, setDataForm] = useState(null);
  const [dataFormSections, setDataFormSections] = useState([]);

  const [statusMsg, setStatusMsg] = useState("");
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      alert("NONE");
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`data_captures/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            // console.log(result.data.data);
            setBanner(result.data.data.banner);
            setCampaign(result.data.data.campaign);
            setDataForm(result.data.data.campaign.data_form);
            setPageTitle(
              `${result.data.data.campaign.account.name} | ${result.data.data.campaign.title}`
            );
          } else {
            // setSeverity("error");
            // setErrMsg(result.data.data.message);
            // setOpen(true);
            navigate("/error");
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  useEffect(() => {
    const sections = [];
    if (dataForm === null) {
      return;
    }

    dataForm.form.form.sections.every(async (param) => {
      // console.log(param);
      const sect = <FormSectionBuilder section={param} />;
      sections.push(sect);
      return false;
    });
    // console.log(sections);
    setDataFormSections(sections);
  }, [dataForm]);

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
      },
      userDecisionTimeout: 5000,
    });

  function getGPSCoords() {
    if (!isGeolocationAvailable) {
      return false;
    }

    if (!isGeolocationEnabled) {
      return false;
    }

    if (coords) {
      return { latitude: coords.latitude, longitude: coords.longitude };
    }

    return false;
  }

  function getFormFieldDisplayName(fieldRef) {
    if (dataForm === null) {
      return "Unknown field";
    }

    let dName = "";
    dataForm.form.form.sections.every((section) => {
      section.fields.every((field) => {
        if (field.reference === fieldRef) {
          dName = `${field.display_name} (${section.title})`;
        }
        return true;
      });
      return true;
    });

    return dName ? dName : false;
  }

  function preprocessDataForm() {
    /* eslint-disable no-restricted-syntax */

    const dForm = document.querySelector(`#dataForm`);
    const formData = new FormData(dForm);
    // console.log(...formData);

    for (const entry of formData.entries()) {
      if (entry[1].length <= 0) {
        setSeverity("error");
        const dF_fieldName = getFormFieldDisplayName(entry[0]);
        if (dF_fieldName === false) {
          continue;
        }
        setErrMsg(`${dF_fieldName} is required`);
        setOpen(true);
        return false;
      }
    }

    let exludedName = "";
    let excluded = false;

    dataForm.form.form.sections.every((section) => {
      const ex = section.fields.every((field) => {
        if (!formData.has(field.reference)) {
          excluded = true;
          exludedName = `${field.display_name} (${section.title})`;
          return false;
        }
        return true;
      });

      return ex;
    });

    if (excluded === true) {
      setErrMsg(`${exludedName} is not provided.`);
      setOpen(true);
      return false;
    }

    const values = Object.fromEntries(formData.entries());
    // const postJson = JSON.stringify(values);
    return values;
  }

  async function capture() {
    const gpsCoords = getGPSCoords();
    console.log(gpsCoords);
    if (!gpsCoords) {
      setSeverity("error");
      setErrMsg("Please enable and allow browser's location and GPS access.");
      setOpen(true);
      return;
    }

    let dataFormValues = {};
    if (dataForm !== null) {
      const values = preprocessDataForm();
      if (values === false) {
        return;
      }
      dataFormValues = values;
    } else {
      setSeverity("error");
      setErrMsg("Data form not initialized. Select a campaign to proceed.");
      setOpen(true);
      return;
    }
    // console.log(dataFormValues);

    if (window.confirm("Are you sure you want to proceed?") === false) {
      return;
    }

    setShowLoading(true);
    const json = {
      reference: ref,
      campaign: campaign.reference,
      form: dataForm.reference,
      data: dataFormValues,
      latitude: gpsCoords.latitude,
      longitude: gpsCoords.longitude,
    };

    console.log(json);

    await axios
      .post("data_captures/capture.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setErrMsg(result.data.data.message);
          setStatusMsg(result.data.data.message);
          setOpenSuccessDialog(true);
        } else {
          // setSeverity("error");
          // setErrMsg(result.data.data.message);
          // setOpen(true);

          setStatusMsg(result.data.data.message);
          setOpenErrorDialog(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        // setSeverity("error");
        // setErrMsg("An error occurred.");
        // setOpen(true);

        setStatusMsg("An unexpected error occurred. Please try again later.");
        setOpenErrorDialog(true);
      });
  }

  return (
    <>
      <Box mb={5}>
        <Container>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={showLoading}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={handleClose}
              severity={severity}
              sx={{ width: "100%" }}
            >
              {errorMsg}
            </Alert>
          </Snackbar>
          <Dialog open={openSuccessDialog} fullWidth maxWidth="xs">
            <DialogContent>
              <Box mt={3} align="center" mb={3}>
                <Box>
                  <Box mt={1}>
                    <Box sx={{ position: "relative", display: "inline-flex" }}>
                      <CircularProgress
                        variant="determinate"
                        size={120}
                        thickness={2}
                        color="success"
                        value={100}
                      />
                      <Box
                        sx={{
                          top: 0,
                          left: 0,
                          bottom: 0,
                          right: 0,
                          position: "absolute",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon color="success" fontSize="large">
                          check
                        </Icon>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box mt={2}>
                  <Typography variant="h6" fontWeight="light">
                    {errorMsg}
                  </Typography>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setOpenSuccessDialog(false);
                  window.location.reload();
                }}
                color="primary"
                iconOnly
                circular
                variant="outlined"
              >
                <Icon>close</Icon>
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={openErrorDialog} fullWidth maxWidth="xs">
            <DialogContent>
              <Box mt={3} align="center" mb={3}>
                <Box>
                  <Box mt={1}>
                    <Box sx={{ position: "relative", display: "inline-flex" }}>
                      <CircularProgress
                        variant="determinate"
                        size={120}
                        thickness={2}
                        color="error"
                        value={100}
                      />
                      <Box
                        sx={{
                          top: 0,
                          left: 0,
                          bottom: 0,
                          right: 0,
                          position: "absolute",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon color="error" fontSize="large">
                          close
                        </Icon>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box mt={2}>
                  <Typography variant="h6" fontWeight="light">
                    {statusMsg}
                  </Typography>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setOpenErrorDialog(false);
                }}
                color="dark"
                iconOnly
                circular
                variant="outlined"
              >
                <Icon>close</Icon>
              </Button>
            </DialogActions>
          </Dialog>

          {campaign !== null ? (
            <Box sx={{ margin: "5px auto", maxWidth: "600px" }}>
              <Box>
                <Paper elevation={0}>
                  <Box p={2} align="center">
                    <Box>
                      <img
                        src={`${AppConfig.api_media_url}${banner}`}
                        alt="img"
                        style={{ maxWidth: "40%", maxHeight: "100%" }}
                      />
                    </Box>
                    <Box mt={3}>
                      <Typography variant="subtitle1" fontWeight={500}>
                        {campaign.account.name}
                      </Typography>
                    </Box>
                    <Box mt={1}>
                      <Typography variant="caption" fontWeight={350}>
                        {campaign.title}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Box>
              {campaign.description.length > 0 ? (
                <Box mt={3}>
                  <Paper elevation={3}>
                    <Box p={2}>
                      <Box>
                        <Typography variant="caption" fontWeight="regular">
                          DESCRIPTION
                        </Typography>
                      </Box>
                      <Box mt={2}>
                        <Typography variant="caption" fontSize={12}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: campaign.description,
                            }}
                          />
                        </Typography>
                      </Box>
                    </Box>
                  </Paper>
                </Box>
              ) : (
                <> </>
              )}

              {dataForm !== null ? (
                // <form id={dataForm.reference}>
                <form id="dataForm">
                  {dataFormSections.map((section) => (
                    <Box mt={5} mb={3}>
                      <Paper elevation={3}>
                        <Box px={3} py={3}>
                          {section}
                        </Box>
                      </Paper>
                    </Box>
                  ))}
                </form>
              ) : (
                <> </>
              )}

              <Box mt={7} align="center">
                <Button
                  size="large"
                  sx={{ width: { xs: "100%", md: "100%", lg: "100%" } }}
                  endIcon={<Icon>save</Icon>}
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    capture();
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          ) : (
            <> </>
          )}
        </Container>
      </Box>
      <CheckoutFooter />
    </>
  );
}

export default DataCapturePage;
